import Vue from 'vue'
import VueLodash from 'vue-lodash'
import { capitalize, toUpper, find, merge, isEqual, remove, cloneDeep, includes, filter, kebabCase } from 'lodash'

Vue.use(VueLodash, { name: 'custom', lodash: { capitalize, toUpper, find, merge, isEqual, remove, cloneDeep, includes, filter, kebabCase } })
